import _toConsumableArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import department from '_c/department';
import job from '_c/jobSelect';
import JobStatus from '_c/job-status';
import LinearSuperior from '_c/linear-superior';
import { attendanceMonth, attendanceMonthExcel, attendanceMonthField, attendanceMonthColor, attendanceMonthUpdate } from 'api/Attendance/monthly-statistics';
import TableDetail from './table-detail';
export default {
  props: {
    cData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    // 部门
    department: department,
    // 职位
    job: job,
    // 在职状态
    JobStatus: JobStatus,
    // 直线上级
    LinearSuperior: LinearSuperior,
    // 表格点击详情
    TableDetail: TableDetail
  },
  data: function data() {
    return {
      title: '',
      // 标题
      colors: [],
      // 颜色列表
      dynamicColumns: {
        basic: [],
        // 基础信息
        attendance: [] // 考勤统计
      },

      ckeckedColumns: [],
      // 缓冲区已选中
      ckeckedColumnsAttdance: [],
      // 考勤统计缓冲区已选中
      tableCheckColumn: [],
      // 表格区动态项 更新报表从缓冲区更新到表格列
      checkAll: true,
      // 是否全选
      checkAllAttdance: true,
      // 考勤统计全选
      isIndeterminate: false,
      // 基础信息 是否半选 优先于全选
      isIndeterminateAttdance: false,
      // 考勤统计 规则同上
      loading: false,
      // 表格loading
      tableData: [],
      // 表格数据
      tableDays: [],
      // 表格天数列
      form: {
        count: 0,
        date: ['2021-11-16', '2021-12-15'],
        month_cycle_id: 0,
        // 月度汇总周期ID,从考勤周期列表中获取，本月时为0时就传0
        search_name: '',
        // 员工
        page: 1,
        page_size: 20,
        start_date: '2021-11-16',
        // 开始日期
        end_date: '2021-12-15',
        // 结束日期
        department_id: '',
        // 部门ID
        manager_id: '',
        // 直线上级ID
        field_key: [],
        // 导出表头，使用attendanceMonthField接口中的field_key字段
        states: ['1', '3'] // 默认选中 在职 待离职
      },

      isShowUpdateTips: false
    };
  },
  created: function created() {
    var _this = this;
    // 数据初始化 参数说明见this.form
    var _this$cData = this.cData,
      begin = _this$cData.begin,
      end = _this$cData.end,
      month_cycle_id = _this$cData.month_cycle_id,
      month = _this$cData.month;
    this.form.date = [begin, end];
    this.form.start_date = begin;
    this.form.end_date = end;
    this.form.month_cycle_id = month_cycle_id;
    this.title = month;
    // 搜索
    this.handlerSearch();
    // 初始化赋值
    // 获取动态列
    attendanceMonthField().then(function (res) {
      _this.dynamicColumns = res.data;
      // 基础信息 考勤统计
      var _this$dynamicColumns = _this.dynamicColumns,
        basic = _this$dynamicColumns.basic,
        attendance = _this$dynamicColumns.attendance;
      // 默认全选 取消半选
      _this.ckeckedColumns = basic; // [...basic, ...attendance]
      _this.ckeckedColumnsAttdance = attendance;
      _this.tableCheckColumn = basic.concat(attendance);
      _this.checkAll = true;
      _this.isIndeterminate = false;
    });
    // 获取所有颜色
    attendanceMonthColor().then(function (res) {
      _this.colors = res.data;
    });
  },
  methods: {
    doShowUpdateTips: function doShowUpdateTips() {
      if (this.isShowUpdateTips) return;
      this.isShowUpdateTips = true;
    },
    // 获取详情参数
    // @parma { Object } detailColumnKeys 循环的数据查询的key对象
    // @parma { Object } row 当前行
    handleShowDetail: function handleShowDetail(detailColumnKeys, row) {
      // 获取详情时候的参数
      var detail_type = detailColumnKeys.detail_type,
        detail_type_id = detailColumnKeys.detail_type_id;
      var _this$form = this.form,
        start_date = _this$form.start_date,
        end_date = _this$form.end_date,
        month_cycle_id = _this$form.month_cycle_id;
      // 参数说明见当前目录下 table-detail.vue
      this.$refs.tableDetail.init({
        start_date: start_date,
        end_date: end_date,
        type: detail_type,
        staff_id: row.staff_id,
        type_id: detail_type_id,
        month_cycle_id: month_cycle_id
      });
      // console.log(detail_type)
    },
    // 动态列选项状态变化
    handleCheckedCitiesChange: function handleCheckedCitiesChange(checkedColumns, type) {
      this.doShowUpdateTips();
      var length = this.dynamicColumns[type].length;
      // 全选则length等于基本信息和考勤统计之和
      this[type === 'basic' ? 'checkAll' : 'checkAllAttdance'] = checkedColumns.length === length;
      // 半选则已选大于0且小于他俩之和length
      this[type === 'basic' ? 'isIndeterminate' : 'isIndeterminateAttdance'] = checkedColumns.length > 0 && checkedColumns.length < length;
    },
    // 动态列全选
    handleCheckAllChange: function handleCheckAllChange(isCheckAll, type) {
      this.doShowUpdateTips();
      // 是否全选
      this[type === 'basic' ? 'ckeckedColumns' : 'ckeckedColumnsAttdance'] = isCheckAll ? this.dynamicColumns[type] : [];
      // 取消半选
      this[type === 'basic' ? 'isIndeterminate' : 'isIndeterminateAttdance'] = false;
    },
    // 更新列表
    handleUpdateColums: function handleUpdateColums() {
      this.tableCheckColumn = [].concat(_toConsumableArray(this.ckeckedColumns), _toConsumableArray(this.ckeckedColumnsAttdance));
      this.handlerSearch('update');
    },
    //  分页相关
    handleSizeChange: function handleSizeChange(val) {
      this.form.page_size = val;
      this.handlerSearch();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.form.page = val;
      this.handlerSearch();
    },
    // 部门选择
    handlerChangeDep: function handlerChangeDep(_, b) {
      this.form.department_id = b.slice(-1)[0];
    },
    // 搜索 表格数据
    handlerSearch: function handlerSearch(type) {
      var _this2 = this;
      this.loading = true;
      // 存在type时则更新后台数据
      var requestMethods = type === 'update' ? attendanceMonthUpdate : attendanceMonth;
      requestMethods(this.form).then(function (res) {
        // console.log(res)
        var _res$data = res.data,
          datalist = _res$data.datalist,
          m_d = _res$data.days.m_d,
          count = _res$data.count;
        // 表格数据
        _this2.tableData = datalist;
        // 表格天数
        _this2.tableDays = m_d;
        // 表格数据总数
        _this2.form.count = count;
        // 更新时提示
        type === 'update' && _this2.$message.success(_this2.$t('1971'));
      }).finally(function () {
        return _this2.loading = false;
      });
    },
    get_field_key: function get_field_key() {
      var _this$ckeckedColumns, _this$ckeckedColumnsA;
      var keys = [].concat(_toConsumableArray(((_this$ckeckedColumns = this.ckeckedColumns) === null || _this$ckeckedColumns === void 0 ? void 0 : _this$ckeckedColumns.map(function (item) {
        return item.field_key;
      })) || []), _toConsumableArray(((_this$ckeckedColumnsA = this.ckeckedColumnsAttdance) === null || _this$ckeckedColumnsA === void 0 ? void 0 : _this$ckeckedColumnsA.map(function (item) {
        return item.field_key;
      })) || []));
      return keys;
    },
    // 导出
    handlerAttendanceExcel: function handlerAttendanceExcel() {
      this.form.field_key = this.get_field_key();
      attendanceMonthExcel(this.form).then(function (res) {
        var object_url = res.data.object_url;
        if (object_url) window.location.href = object_url;
      });
    }
  }
};